/**
 * Generates a base64-encoded GUID using browser crypto APIs.
 *
 * Note: By design, this function produces a guid in a different format from backend GUIDs.
 * This avoids confusing frontend-generated IDs with backend-generated GUIDs.
 *
 * @example dcWyqxUedy-c5owG_HIlsA
 *
 * TODO: Move to a shared utilities package in the future (https://seeq.atlassian.net/browse/CRAB-57828)
 */
export function base64guid(): string {
  const array = new Uint8Array(16); // 128 bits of randomness
  window.crypto.getRandomValues(array);
  return (
    window
      .btoa(String.fromCharCode.apply(null, Array.from(array)))
      // Remove url unsafe characters and padding
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')
  );
}
